import "core-js/modules/es6.object.assign";
import { useAntdTable } from '..';
import { fieldAdapter, resultAdapter } from './fusionAdapter';

function useFusionTable(service, options) {
  var ret = useAntdTable(service, Object.assign(Object.assign({}, options), {
    form: options.field ? fieldAdapter(options.field) : undefined
  }));
  return resultAdapter(ret);
}

export default useFusionTable;